/*
 * Public API Surface of dhis2-dashboard
 */

export * from './lib/dhis2-dashboard.module';
